import React from 'react';
import {
  Stack,
  IconButton,
  MessageBarType,
  MessageBar,
  useTheme,
  Text,
  Icon,
} from '@fluentui/react';
import { useCommonStyles } from 'common/styles';

type ToastProps = {
  message: string;
  type?: 'success' | 'error' | 'info' | 'custom' | 'warning';
  onClose?: () => void;
};

const getMessageBarType = (type: ToastProps['type']) => {
  switch (type) {
    case 'success':
      return MessageBarType.success;
    case 'error':
      return MessageBarType.error;
    case 'info':
      return MessageBarType.info;
    case 'warning':
      return MessageBarType.warning;
    default:
      return MessageBarType.severeWarning;
  }
};

export const CustomToast: React.FC<ToastProps> = ({
  message,
  type = 'custom',
  onClose,
}) => {
  const theme = useTheme();
  const commonStyles = useCommonStyles();

  const backgroundColor =
    type === 'success'
      ? theme.palette.green
      : type === 'error'
      ? theme.palette.redDark
      : theme.palette.blue;

  const iconName =
    type === 'success'
      ? 'Accept'
      : type === 'error'
      ? 'StatusCircleInfo'
      : 'StatusCircleInfo';
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      verticalAlign="center"
      styles={{
        root: {
          backgroundColor,
          padding: 20,
          borderRadius: 2,
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          maxWidth: 360,
        },
      }}
    >
      <Stack horizontal styles={{ root: { flexGrow: 1, minWidth: 0 } }}>
        <Stack
          horizontalAlign="center"
          verticalAlign="center"
          styles={{
            root: {
              height: 25,
              width: 25,
              border: '1px solid white',
              borderRadius: 20,
              backgroundColor: '#FFFFFF11',
              flexShrink: 0,
              marginRight: 12,
            },
          }}
        >
          <Icon
            iconName={iconName}
            styles={{ root: { fontSize: 12 } }}
            className={commonStyles.colorStaticWhite}
          />
        </Stack>

        <Text
          variant="large"
          className={commonStyles.colorStaticWhite}
          styles={{
            root: {
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            },
          }}
        >
          {message}
        </Text>
      </Stack>

      {onClose && (
        <IconButton
          iconProps={{ iconName: 'Cancel' }}
          title="Close"
          ariaLabel="Close"
          onClick={onClose}
          styles={{
            icon: { color: 'white' },
            iconHovered: { color: 'white' },
            rootHovered: { backgroundColor: theme.palette.greenDark },
          }}
        />
      )}
    </Stack>
  );
};
